import React, { useEffect, useState } from 'react';
import './App.css';
import ClientList from './ClientList/ClientList';
import { Component } from './menu';
import { Routes, Route } from "react-router-dom";
import StockList from './StockList/StockList';
import Budget from './Budget/Budget';
import Machine from './Machine/Machine';
import Login from './Login/Login';
import Invoice from './Invoice/Invoice';

function App() {
	const [path, setPath] = useState<string>('');
	useEffect(() => {
		const path = window.location.pathname;
		setPath(path);
	}, []);

	return (
		<div className="App flex min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
			{path !== "/login" && <Component />}
			<main className="flex-1 overflow-auto">
				<Routes>
					<Route
						path="/"
						element={
							<div className="page-container">
								<ClientList />
							</div>
						}
					/>
					<Route
						path="stock"
						element={
							<div className="page-container">
								<StockList />
							</div>
						}
					/>
					<Route
						path="budget"
						element={
							<div className="page-container">
								<Budget />
							</div>
						}
					/>
					<Route
						path="machine"
						element={
							<div className="page-container">
								<Machine />
							</div>
						}
					/>
					<Route
						path="invoices"
						element={
							<div className="page-container">
								<Invoice />
							</div>
						}
					/>
					<Route
						path="login"
						element={<Login />}
					/>
				</Routes>
			</main>
		</div>
	);
}

export default App;
